export const hotelReservation: any = {
  status: {
    arranged: "reserved",
    cancelled: "cancelled",
  },
};
